import moment from 'moment';
import { history } from 'common/helpers';

export function createChartsViewModalHandlers({
  getState,
  setState,
  getProps,
  calendarSelect,
  getChartData,
  setChartType
}) {
  const openAddEditFeatures = (feature = undefined) => {
    const { config, tag } = getState();
    if (!config.spectrumFeatures) {
      getProps().spectrumFeatureActions.getSpectrumFeatures(tag.id, config.config_id).then(
        (res) => {
          setState(prevState => ({
            config: { ...prevState.config, spectrumFeatures: { items: res } }
          }));
        });
    }
    if (!config.spectrum) {
      getProps().assetDetailsActions.getTagSpectrum(
        tag.id,
        { amp_type: tag.amp_type },
        config.config_id
      ).then(
        (res) => {
          setState((prevState) => {
            const updatedConfig = { ...prevState.config };
            updatedConfig.spectrum = res;
            return { config: updatedConfig };
          });
        });
    }
    setState({
      showCharts: false,
      openFeature: true,
      featureToOpen: feature,
      addingNote: false
    });
  };

  const closeAddEditFeature = () => {
    setState({
      openFeature: false,
      showCharts: true
    });
  };

  const edit = () => {
    const state = getState();
    if (state.editTrend) setState({ editTrend: false, showCharts: true });
    else if (state.openFeature) setState({ openFeature: false, showCharts: true });
    else if (state.openOverallAlarm) {
      setState({ openOverallAlarm: false, showCharts: true });
      setChartType('trend');
    } else if (state.envelopeAlarm) {
      setState({ envelopeAlarm: false, showCharts: true });
      setChartType('trend');
    } else if (state.editDemod) setState({ editDemod: false, showCharts: true });
    else if (state.editRULSettings) setState({ editRULSettings: false });
    else setState({ editTrend: true, showCharts: false, addingNote: false });
  };

  const openEnvelopeAlarm = () => {
    setState({
      envelopeAlarm: true,
      showCharts: false,
      addingNote: false,
      editTagInfo: false,
      editRULSettings: false
    });
  };

  const closeEnvelopeAlarm = () => {
    setState({
      showCharts: true,
      envelopeAlarm: false
    });
    // Closing the Alarm page should return to the Trend view, regardless of
    // which chart type was active before it was opened.
    setChartType('trend');
  };

  const openEditTrend = () => {
    setState({
      editTrend: true,
      showCharts: false,
      addingNote: false,
      editTagInfo: false,
      editRULSettings: false
    });
  };

  const openEditTagInfo = () => {
    setState({
      editTagInfo: true,
      editTrend: false,
      showCharts: false,
      addingNote: false,
      editRULSettings: false
    });
  };

  const openRULSettings = () => {
    let newStartTime = null;
    const { tag } = getState();
    if (tag.rul_settings && (tag.rul_settings.start_time || tag.rul_settings.fdp)) {
      if (tag.rul_settings.start_time) newStartTime = moment(tag.rul_settings.start_time);
      else newStartTime = moment(tag.rul_settings.fdp);
      newStartTime = new Date(newStartTime.subtract(10, 'days'));
    }
    setState({
      editTagInfo: false,
      editTrend: false,
      showCharts: true,
      addingNote: false,
      editRULSettings: true
    }, () => newStartTime ? calendarSelect('custom', newStartTime, new Date(moment())) : {});
  };

  const closeRULSettings = () => {
    setState({
      editTagInfo: false,
      editTrend: false,
      showCharts: true,
      addingNote: false,
      editRULSettings: false
    });
  };

  const closeEditTrend = () => {
    setState({
      editTrend: false,
      editTagInfo: false,
      showCharts: true
    });
  };

  const onFeatureDetailsClick = (feature) => {
    setState(prevState => ({
      openFeatureDetails: true,
      featureForDetails: feature,
      showCharts: !prevState.showCharts
    }));
  };

  const closeFeatureDetailsClick = () => {
    setState(prevState => ({
      openFeatureDetails: false,
      showCharts: !prevState.showCharts
    }));
  };

  const toggleOverallAlarm = () => {
    const wasOpen = getState().openOverallAlarm;
    setState(prevState => ({
      openOverallAlarm: !prevState.openOverallAlarm,
      showCharts: !prevState.showCharts,
      addingNote: false
    }));
    // Closing the Alarm page (it was open) should return to the Trend view,
    // regardless of which chart type was active before it was opened. Go
    // through setChartType (not a raw chartType in the setState above) so
    // session/URL persistence and overlay-point bookkeeping stay consistent
    // with every other chart-type change.
    if (wasOpen) setChartType('trend');
  };

  const toggleAddingNote = () => {
    setState(prevState => ({
      addingNote: !prevState.addingNote,
    }));
  };

  const openEditDemod = () => {
    setState({
      editDemod: true,
      showCharts: false,
      addingNote: false
    });
  };

  const closeEditDemod = (refetchDemod = false) => {
    setState({
      editDemod: false,
      showCharts: true
    });

    if (refetchDemod) {
      getChartData({ amp_type: 'demod' });
    }
  };

  const openBaselinePage = () => {
    const props = getProps();
    history.push(`/machines/${props.machine_id ? props.machine_id : props.breadcrumb.machine.id}/baseline`);
  };

  return {
    openAddEditFeatures,
    closeAddEditFeature,
    edit,
    openEnvelopeAlarm,
    closeEnvelopeAlarm,
    openEditTrend,
    openEditTagInfo,
    openRULSettings,
    closeRULSettings,
    closeEditTrend,
    onFeatureDetailsClick,
    closeFeatureDetailsClick,
    toggleOverallAlarm,
    toggleAddingNote,
    openEditDemod,
    closeEditDemod,
    openBaselinePage
  };
}
